import { createFileRoute } from "@tanstack/react-router";

import { MembersLayout } from "@layouts/MembersLayout/";

export const Route = createFileRoute("/members")({
  component: MembersLayout,
});
